<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div class="page-actions" style="display: flex; justify-content: space-between">
        <div class="select">
          <div class="item">
            <div class="ipt">
              <el-input placeholder="trackNo" clearable v-model="trackNo" size="mini">
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-input placeholder="orderId" clearable v-model="orderId" size="mini">
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-input placeholder="userId" clearable v-model="userId" size="mini">
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select v-model="userType" placeholder="用户类型" clearable size="mini">
                <el-option v-for="item in userTypeArr" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select v-model="working" placeholder="订单状态" clearable size="mini">
                <el-option v-for="item in statusArr" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select v-model="symbol" placeholder="交易对" clearable size="mini">
                <el-option v-for="item in symbolList" :key="item.symbol" :label="item.symbol.toLocaleUpperCase()"
                  :value="item.symbol">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-date-picker v-model="times" type="daterange" format="yyyy 年 MM 月 dd 日" range-separator="至"
                start-placeholder="开仓开始日期" end-placeholder="开仓结束日期" value-format="timestamp" size="mini">
              </el-date-picker>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-date-picker v-model="closeTimes" type="daterange" format="yyyy 年 MM 月 dd 日" range-separator="至"
                start-placeholder="平仓开始日期" end-placeholder="平仓结束日期" value-format="timestamp" size="mini">
              </el-date-picker>
            </div>
          </div>
          <div class="item">
            <el-button size="mini" @click="clearFiled">重置</el-button>
          </div>
          <div class="item">
            <el-button size="mini" type="primary" @click="handleSearch({ page: 1 })">查询</el-button>
          </div>
        </div>
      </div>
      <el-table :data="tabList" height="500">
        <el-table-column label="userId" prop="userId" align="center" />
        <el-table-column prop="" label="订单状态" align="center">
          <template slot-scope="scope">
            <span> {{ scope.row.working ? "未完成" : "已完成" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="orderId" prop="orderId" align="center" width="180" />
        <el-table-column label="合约名" prop="symbol" align="center" />
        <el-table-column label="平仓均价" prop="closePrice" align="center" />
        <el-table-column label="已成交数量" prop="closeSize" width="120" align="center" />
        <el-table-column label="手续费" prop="fee" align="center" />
        <el-table-column label="杠杆" prop="openLeverage" align="center" />
        <el-table-column label="开仓均价" prop="openPrice" align="center" />
        <el-table-column label="开仓数量" prop="openSize" align="center" />
        <el-table-column prop="" label="下单方向:" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.orderSide == 2">卖</span>
            <span v-if="scope.row.orderSide == 1">买</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="订单类型" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.orderType == 2">市价</span>
            <span v-if="scope.row.orderType == 1">限价</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="开仓方向" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.positionSide == 2">空</span>
            <span v-if="scope.row.positionSide == 1">多</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="仓位模式" prop="positionType" align="center" /> -->
        <el-table-column label="平仓盈亏" prop="realizedPnl" align="center" />
        <el-table-column label="追踪号" prop="trackNoStr" align="center" width="180" />
        <!-- <el-table-column prop="" label="用户类型" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.userType == 2">跟单员</span>
            <span v-if="scope.row.userType == 1">交易员</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="userTypeStr" label="用户类型" align="center" />

        <el-table-column label="创建时间" width="160" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.openTime | moment }}</span>
          </template>
        </el-table-column>
        <el-table-column label="平仓时间" width="160" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.closeTime">{{ scope.row.closeTime | moment }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination :size="pagination.size" :total="totalCount" :page="pagination.page" @pageChanged="paginationHandle">
      </pagination>
    </el-card>
  </div>
</template>

<script>
import Pagination from "components/pagination";
import api from "./api";

export default {
  components: {
    Pagination,
  },
  computed: {
    queryStartDate() {
      return Array.isArray(this.times) && this.times[0] ? this.times[0] : "";
    },
    /** 结束日期对齐到当天 23:59:59.999（与 daterange 结束日一致） */
    queryEndDate() {
      if (!Array.isArray(this.times) || !this.times[1]) return "";
      const d = new Date(this.times[1]);
      d.setHours(23, 59, 59, 999);
      return d.getTime();
    },
    closeStartDate() {
      return Array.isArray(this.closeTimes) && this.closeTimes[0] ? this.closeTimes[0] : "";
    },
    closeEndDate() {
      if (!Array.isArray(this.closeTimes) || !this.closeTimes[1]) return "";
      const d = new Date(this.closeTimes[1]);
      d.setHours(23, 59, 59, 999);
      return d.getTime();
    },
  },
  data() {
    return {
      userType: "0",
      orderId: "",
      userId: "",
      tabList: [],
      totalCount: 0,
      pagination: {
        page: 1,
        size: 25,
      },
      userTypeArr: [
        { label: "全部", value: "0" },
        { label: "交易员", value: "1" },
        { label: "跟单员", value: "2" },
      ],
      working: "",
      statusArr: [
        { label: "全部", value: "" },
        { label: "已完成", value: false },
        { label: "未完成", value: true },
      ],
      symbolList: [],
      symbol: "",
      trackNo: "",
      times: [],
      closeTimes: [],
    };
  },
  mounted() {
    api.getSymbolList({ type: "CONTRACT" }).then((res) => {
      if (res.code == 0) {
        this.symbolList = res.data;
      }
    });
    this.handleSearch();
  },
  methods: {
    clearFiled() {
      this.userType = "0";
      this.orderId = "";
      this.userId = "";
      this.symbol = "";
      this.trackNo = "";
      this.times = [];
      this.closeTimes = [];
      this.working = "";
      this.handleSearch({ page: 1 });
    },
    handleSearch(data = {}) {
      api
        .copytradeOrderHistory({
          userType: this.userType,
          orderId: this.orderId,
          userId: this.userId,
          symbol: this.symbol,
          trackNo: this.trackNo,
          startDate: this.queryStartDate,
          endDate: this.queryEndDate,
          closeStartDate: this.closeStartDate,
          closeEndDate: this.closeEndDate,
          working: this.working,
          ...this.pagination,
          ...data,
        })
        .then((res) => {
          if (res.code == 0) {
            const { total, items } = res.data;
            this.tabList = items;
            this.totalCount = total;
          }
        });
    },
    paginationHandle(pagination) {
      this.pagination = pagination;
      this.handleSearch();
    },
  },
};
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
<style scoped lang="less">
.avatar {
  width: 50px;
  height: 50px;
}
</style>
